import React from 'react';
import Secondgrade_k2 from './secondgrade_k2';
import Secondgrade_k2_subjects from './secondgrade_k2_subjects';
const Secondgrade_k2math = () => {
  return (
    <div>
      <Secondgrade_k2 />
    <Secondgrade_k2_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>Mathematics section</h1>
      <h3>English section in the curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in agriculture learning and assessment </li>
      <li>Cross-cutting isues integrated in Agriculture learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Secondgrade_k2math;